import HeaderSection from '../../../../components/Header/HeaderSection';
import CardTransparent from '../../../../components/CockpitCards/CardTransparent';


export default function GeneticsSearchText() {

    
    return (

      <CardTransparent content = {
        <HeaderSection

            headline_p1 = "Explore your entire genome for" 
            headline_grey = "specific variants"
            headline_p2 = ""

            text1 = "This section lets you search across your whole genome to find specific genetic variants that matter to you."
            text2 = "You have three easy ways to explore your data: By gene name, by dbDNP rs-number or by a ClinVar ID. Just type your search term, click Submit, and if a variant is found, you'll get clear information about its location, type, consequence, and clinical classification. This tool gives you the power to dive deeper into your genome and discover important details that can support your health journey."
            text3 = "Important: Use correct gene symbols, rs-numbers, or ClinVar IDs to ensure accurate results.This tool is designed to support targeted searches within your whole genome and assist you and your healthcare provider in understanding your genetic profile more deeply."

            />
    }/>
            
  )
}